/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import InvestorCharter from "./investor-charter";

export default InvestorCharter;
